export default "__VITE_ASSET__be225e5e__"